/* eslint-disable no-else-return */
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Card, Typography, Button, Result } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';

const { Paragraph } = Typography;

function StripeSuccessPage() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Get userType directly from URL params
  const searchParams = new URLSearchParams(location.search);
  const userType = searchParams.get('userType');
  const userId = searchParams.get(`${userType}_id`);

  // Derive dashboard URL based on user type
  const dashboardUrl = `/${userType}/wallet/details`;

  useEffect(() => {
    // Optionally verify the account setup status with your backend
    // You could make an API call here to confirm everything is properly set up
  }, [userId, userType]);

  const handleContinue = () => {
    setLoading(true);
    navigate(dashboardUrl);
  };

  // Custom messages based on user type
  const getCustomContent = () => {
    if (userType === 'borrower') {
      return {
        title: 'Your Stripe account is connected!',
        subtitle: "You've successfully connected Your manager account with our payment processor.",
        message: 'You can now receive funding directly to your bank account.',
      };
    } else if (userType === 'investor') {
      return {
        title: 'Your Stripe account is connected!',
        subtitle: "You've successfully connected your investor account with our payment processor.",
        message: 'You can now receive investment returns directly to your bank account.',
      };
    } else {
      return {
        title: 'Your Stripe account is connected!',
        subtitle: "You've successfully connected your account with our payment processor.",
        message: 'You can now manage your finances through our platform.',
      };
    }
  };

  const content = getCustomContent();

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '48px 24px',
      }}
    >
      <Card style={{ maxWidth: '560px', margin: '0 auto' }}>
        <Result
          icon={<CheckCircleFilled style={{ color: '#52c41a' }} />}
          title={content.title}
          subTitle={content.subtitle}
          extra={
            <div style={{ textAlign: 'center' }}>
              <Paragraph>{content.message}</Paragraph>
              <Button type="primary" size="large" onClick={handleContinue} loading={loading}>
                Continue to Dashboard
              </Button>
            </div>
          }
        />
      </Card>
    </div>
  );
}

export default StripeSuccessPage;
